import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { AppointmentDetail } from '../../business-entities/appointmentDetail-model';
import { AppointmentStatusList } from '../../business-entities/appointmentStatus-model';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { SaveAppointmentPlanning } from '../../business-entities/save-appointment-planning.model';
import { Features } from '../../business-entities/user-role-view-model';
import { AppointmentPlanningService } from '../../business-services/appointment-planning.service';
import { AppointmentService } from '../../business-services/appointment.service';
import { BrandService } from '../../business-services/brand.service';
import { EditAppointmentService } from '../../business-services/edit-appointment.service';
import { AddBookingComponent } from '../../views/appointment/edit-appointment/appointment-planning/add-booking/add-booking.component';
import { AppointmentScheduleModel } from './../../business-entities/appointment-schedule.model';
import { MechanicDaySchedulerViewModel } from './../../business-entities/mechanic-day-schedule.model';
import { MultiStackPopupService } from '../../services/multi-stack-popup.service';
import { AppointmentServiceDetails } from '../../business-entities/appointment-service-details-view-model';
import { BlockMechanicComponent } from '../block-mechanic/block-mechanic.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { MechanicService } from '../../business-services/mechanic.service';

@Component({
    selector: 'af-app-scheduler-day-view',
    templateUrl: './scheduler-day-view.component.html',
    styleUrls: ['./scheduler-day-view.component.css']
})

export class SchedulerDayViewComponent implements OnInit {
    @Input() appointmentSchedule: AppointmentScheduleModel;
    @Input() isViewAppointment = false;
    @Input() daySchedulerViewModel: MechanicDaySchedulerViewModel;
    @Input() selectedDate: Date;
    @Input() dealerName: string;
    @Input() hours: Array<number> = [];
    @Input() schedulerModal: any;
    @Output() showAddBooking = new EventEmitter<boolean>();
    @Input() isView: boolean;
    @Input() duration: any;
    @Input() isReadOnly: boolean;
    @Input() totalDuration: any
    @Input() totalServiceTime: any
    @Input() selectedDealerId: string = '';
    @Input() calendarNumber: number = 0;
    @Input() serviceDetail: AppointmentServiceDetails;
    scrollLeft: number;
    isPaste: boolean = false;
    isShowDelete: boolean = false;
    isShowView: boolean = false;
    isShowViewOnly:boolean=false;
    isClickOnCut: boolean = false;
    openContextId: string = '';
    appointmentDate: Date;
    closeResult: string;
    isDisplayMouseHoverId: number = null
    isDisplayMouseHoverMechanicId: number = null;
    dealerTimeSlotWidth: number = 2160;
    horzDateBoxDayWidth: number;
    appointmentId: number;
    timeSlotWidth = 25;
    slotDetailPosition: number = 0;
    idSpaceFromPlannerTopOffset: number;
    isDisplayMouseHoverDetail = false;
    dragData: any;
    dragMechanicData: any;
    dragPlanningBookingId: number;
    dragPlanningTime: string;
    dealerId: string = "";
    idOfContext: any;
    popupCloseResult = false;
    appointmentSlotDetails = {
        appointmentId: null,
        customerName: '',
        licensePlate: '',
        mechanicName: '',
        mechanicId: '',
        appointmentStartTime: '',
        appointmentEndTime: '',
        isDisplayMouseHoverDetail: true,
        workOrderNo: null,
        workOrderColor: null,
        brand: null,
        brandCode: null,
        appointmentDemands: [],
        isAnyWarrantyDemand: false
    };
    appointmentDemands  = [];
    contextmenu = false;
    contextmenuX = 0;
    contextmenuY = 0;
    ghostElementPositioning: 'fixed' | 'absolute' = 'absolute';
    singleSlotArea: number;
    WoStatusId: number;
    rightClickMenuItems = [];
    parentElem: any;
    contextMenuSelector: string;
    menuEvent: any;
    brandList: BrandViewModel[];
    appointmentStatusList: AppointmentStatusList[] = [];
    contactDetails: AppointmentDetail;
    reasonForDelete: string = '';
    bookingId: number;
    deleteAppointmentId: number;
    currentTime:Date = new Date();
    isGrayHeaderBorder = false;
    isBlockMechanic:boolean = false;
    isDeleteBlockedMechanic:boolean = false;
    isSyncingScroll: boolean = false;
    mechanicLeaveTypesList: any[] = [];
    leavePopupVisible = false;
    leavePopupPos = { top: 0, left: 0 };
    leavePopupInfo: { leaveType: string; remark: string; colorCode: string } | null = null;

    @ViewChild('contextMenus', { read: ViewContainerRef, static: true }) container;
    @Output() onScrollPlanning = new EventEmitter<{ scrollTop: number; scrollLeft: number }>();

    features: Features[] = [];
    @ViewChild('plannerBody') plannerBody: ElementRef;
    constructor(
        private readonly translate: TranslateService,
        private readonly datePipe: DatePipe,
        private readonly appointmentPlanningService: AppointmentPlanningService,
        private readonly spinner: NgxSpinnerService,
        private readonly toastr: ToastrService,
        private readonly model: NgbModal,
        private readonly editAppointmentService: EditAppointmentService,
        private readonly secureStorage: SecureStorage,
        private readonly appointmentService: AppointmentService,
        private readonly brandService: BrandService,
        private readonly modalService: NgbModal,
        private readonly multiStackPopupService: MultiStackPopupService,
        private service: MechanicService
    ) { 
        setInterval(() => {
            this.currentTime = new Date();
          }, 60000);
    }

    get getCurrentMinuteMargin(): number {
        if (this.currentTime.getMinutes() === 0) {
            return 0;
        } else {
            const percentage = (this.currentTime.getMinutes() / 60) * 100;
            return (percentage / 100) * 120;
        }
    }

    ngOnInit(): void {
        this.isGrayHeaderBorder = localStorage.getItem("Theme") === 'mg';
        this.SetSingleSlotArea();
        if (!this.isView) {
            this.appointmentDate = new Date(this.editAppointmentService.appointmentDetails.bookedDateTime);
            this.appointmentId = this.editAppointmentService.appointmentDetails.id;
            this.WoStatusId = this.editAppointmentService.appointmentDetails.workOrderStatusId;
            this.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
        }
        else {
            this.dealerId = this.selectedDealerId;
        }
        this.features = this.secureStorage.getKeyData('feature');
        if (this.features?.length > 0) {
            this.isBlockMechanic = this.features.find(x => x.featureCode === Enums.FeatureCode.BlockMechanic)?.isActive;
        }
        this.GetMechanicLeaveTypes();
    }
    @HostListener('mouseleave', ['$event']) // for window scroll events
    @HostListener('mousewheel', ['$event']) // for window scroll events
    onMouseLeave() {
        if (this.openContextId && this.openContextId.length > 0) {
            let section = document.querySelector('.' + this.openContextId)
            if (section != null) {
                section.setAttribute('hidden', 'true')
            }
        }
        this.contextmenu = false;
    }

    private SetSingleSlotArea() {
        this.singleSlotArea = 0;
        if (this.daySchedulerViewModel.newSlotArea > 0) {
            this.singleSlotArea = parseFloat(Math.round(this.daySchedulerViewModel.newSlotArea / 4.0).toFixed(2));
        } else {
            this.singleSlotArea = 30;
        }
    }
    handleCommonBehavior() {
        this.isPaste = false;
        this.isShowDelete = true;
        this.isShowView = true;
    }

    updateFlags() {
        this.isPaste = true
        this.isShowDelete = false;
        this.isShowView = false
    }

    //activates the menu with the coordinates
    onrightClick(event, slotAppointment) {
        if (!(slotAppointment?.workOrderStatus == fromEnums.WOStatusName.InvoicePaid || slotAppointment?.workOrderStatus == fromEnums.WOStatusName.Cancelled || slotAppointment?.workOrderStatus == fromEnums.WOStatusName.Closed)) {
            // Check mechanic blocked planning
            if(this.isBlockMechanic && slotAppointment?.isBlocked){
                this.isDeleteBlockedMechanic = slotAppointment?.isBlocked;
            }
            else{
                this.isDeleteBlockedMechanic = false;
            }
            
            // First check planning is allowed on leave and unavability
            
            let planningAllowOnLeave; let isAvailable;
            if (this.features?.length > 0) {
                planningAllowOnLeave = this.features.find(x => x.featureCode === Enums.FeatureCode.AllowPlanningOnLeave)?.isActive;
            }
            if (planningAllowOnLeave) {
                if (slotAppointment?.workOrderStatus == fromEnums.WOStatusName.Workdone) {
                    isAvailable=true;
                }
                else {
                    isAvailable = (
                        !slotAppointment?.isOnLunch &&
                        !slotAppointment?.isOnBreak1 &&
                        !slotAppointment?.isOnBreak2 &&
                        !slotAppointment?.isReserved &&
                        !slotAppointment?.isunplanned
                    )
                }
            }
            else {
                // Add Planning for other WO
                isAvailable = (
                    !slotAppointment?.isOnLunch &&
                    !slotAppointment?.isOnBreak1 &&
                    !slotAppointment?.isOnBreak2 &&
                    !slotAppointment?.isReserved &&
                    !slotAppointment?.isunplanned &&
                    !slotAppointment?.isLeave
                )
            }

            if (isAvailable) {
                this.setupContextMenu(event, slotAppointment)
            }
            else {
                if (!this.isReadOnly && slotAppointment.appointmentId === this.appointmentId && (this.dragPlanningBookingId == 0 || this.dragPlanningBookingId == undefined)) {
                    this.handleCommonBehavior();
                }
                else if (this.isReadOnly && (this.dragPlanningBookingId === 0 || this.dragPlanningBookingId == undefined) && slotAppointment.appointmentId != null) {
                    this.handleCommonBehavior();
                }
                else {
                    this.resetContextMenu();
                    return;
                }
            }

        }

    }

    setupContextMenu(event, slotAppointment) {
        this.contextmenu = true;
        this.idOfContext = event.currentTarget.id
        this.resetContextMenu();
        this.openContextId = event.currentTarget.dataset.cxt;
        this.isShowViewOnly=false;

        let coords = this.getCoords(event);
        this.contextmenuX = coords.left;
        this.contextmenuY = coords.top;
        event.currentTarget.querySelector('.' + event.currentTarget.dataset.cxt).removeAttribute('hidden')
        if (slotAppointment?.isAvailable && (this.dragPlanningBookingId == 0 || this.dragPlanningBookingId == undefined) && slotAppointment?.isSlotInMechanicShift && !slotAppointment?.previousDate) {
            this.isPaste = true;
            this.isClickOnCut = false;
            this.isShowDelete = false;
            this.isShowView = false
        }
        else {
            if (slotAppointment?.workOrderStatus == fromEnums.WOStatusName.Workdone || (slotAppointment?.previousDate && slotAppointment.appointmentId != null)) {
                this.isShowView = true;
                this.isShowViewOnly=true;
            } else {
                if (!this.isReadOnly && (this.dragPlanningBookingId == 0 || this.dragPlanningBookingId == undefined && !slotAppointment?.isAvailable)) {
                    this.handleCommonBehavior()
                }
                else if (this.isReadOnly && (this.dragPlanningBookingId === 0 || this.dragPlanningBookingId == undefined) && (slotAppointment.appointmentId != null || slotAppointment.isBlocked) && !slotAppointment?.isAvailable) {
                    this.handleCommonBehavior()
                }
                else if (!this.isReadOnly && (this.dragPlanningBookingId > 0 && this.dragPlanningBookingId != undefined) && !this.isClickOnCut && !slotAppointment?.isAvailable) {
                    this.handleCommonBehavior()
                }
                else if (this.isReadOnly && (this.dragPlanningBookingId > 0 && this.dragPlanningBookingId != undefined) && !this.isClickOnCut && !slotAppointment?.isAvailable) {
                    this.handleCommonBehavior()
                }
                else if (this.isReadOnly && (this.dragPlanningBookingId === 0 || this.dragPlanningBookingId == undefined) && slotAppointment.appointmentId === null) {
                    this.resetContextMenu();
                    return;
                }
                else if (!this.isReadOnly && (this.dragPlanningBookingId > 0 && this.dragPlanningBookingId != undefined) && this.isClickOnCut && slotAppointment?.isSlotInMechanicShift) {
                    this.updateFlags();
                }
                else if (this.isReadOnly && (this.dragPlanningBookingId > 0 && this.dragPlanningBookingId != undefined) && this.isClickOnCut && slotAppointment?.isSlotInMechanicShift) {
                    this.updateFlags();
                }
                else {
                    this.resetContextMenu();
                    return;
                }
            }
        }
    }

    resetContextMenu() {
        if (this.openContextId?.length > 0) {
            let section = document.querySelector('.' + this.openContextId)
            if (section != null) {
                section.setAttribute('hidden', 'true')
                this.contextmenu = false;
            }
        }

    }

    HideContextMenu(event) {
        event.stopPropagation();
        return false;
    }

    getCoords(elem) {
        let box = elem.target.getBoundingClientRect();
        return {
            top: box.top + window.pageYOffset,
            right: box.right + window.pageXOffset,
            bottom: box.bottom + window.pageYOffset,
            left: box.left + window.pageXOffset
        };
    }
    //disables the menu
    disableContextMenu() {
        this.contextmenu = false;
    }
    open(content, _appointment) {
        this.model.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    private getDismissReason(reason: any): boolean {
        if (reason === ModalDismissReasons.ESC) {
            return false;
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return false;
        } else {
            return reason;
        }
    }
    AddCurrentWOPlanningPopup(event: Event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking) {
        this.AddPlanningPopup(event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking);
    }
    AddWOPlanningPopup(event: Event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking) {
        this.AddPlanningPopup(event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking);
    }

    AddPlanningPopup(event: Event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking) {
        this.features = this.secureStorage.getKeyData('feature');
        let planningAllowOnLeave;
        if (this.features?.length > 0) {
            planningAllowOnLeave = this.features.find(x => x.featureCode === Enums.FeatureCode.AllowPlanningOnLeave)?.isActive;
        }
        if (planningAllowOnLeave && (appointment?.isLeave || appointment?.isNotAvailable)) {
            let modelHeadermsg = this.translate.instant("lblConfirmation");
            let modelBodymsg = this.translate.instant("lblAssociatePlanningOnLeave");
            const modalRef = this.modalService.open(NgbdModalContent);
            modalRef.componentInstance.modelHeader = modelHeadermsg;
            modalRef.componentInstance.modelBody = modelBodymsg;
            modalRef.result.then((_result) => {
                // This is intentional
            }, (reason) => {
                this.popupCloseResult = this.getDismissReason(reason);
                if (this.popupCloseResult) {
                    this.AddPlanning(event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking);

                }
            });
        }
        else {
            if (appointment?.isLeave || appointment?.isNotAvailable) {
                event.preventDefault();
                return;
            }
            else {
                this.AddPlanning(event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking);
            }
        }

    }

    AddPlanning(event: Event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking) {
        if (this.openContextId && this.openContextId.length > 0) {
            let section = document.querySelector('.' + this.openContextId)
            if (section != null) {
                section.setAttribute('hidden', 'true')
            }
            this.contextmenu = false;
        }
        if (!appointment?.isReserved && !appointment?.isunplanned) {
            let compareDate = selectedDate;

            if (selectedDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
                const modalref = this.model.open(AddBookingComponent, { size: 'lg', windowClass: !isAddBooking && 'pop-wid1200' });
                modalref.componentInstance.mechanicName = pText;
                modalref.componentInstance.startDate = compareDate.setHours(slotHour, boxNumber);
                modalref.componentInstance.pId = pId;
                modalref.componentInstance.durationValue = undefined;
                modalref.componentInstance.unavailableDates = undefined;
                modalref.componentInstance.endTime = undefined;
                modalref.componentInstance.dealerId = this.dealerId;
                modalref.componentInstance.mechanicStartTime = slotHour;
                modalref.componentInstance.dealerWorkingHours = this.appointmentPlanningService.dealerWorkingHours;
                modalref.componentInstance.dealerHolidays = this.appointmentPlanningService.dealerHolidays;
                modalref.componentInstance.isServicesAdded = this.appointmentPlanningService.isServicesAdded;
                modalref.componentInstance.calenderStartDate = Utility.GetFormattedDate(new Date());
                modalref.componentInstance.totalTimeDuration = this.duration;
                modalref.componentInstance.boxNumber = boxNumber;
                modalref.componentInstance.moduleId = Enums.ModuleNames.Appointment;
                modalref.componentInstance.integrationWithDMS = false;
                modalref.componentInstance.realtimeDmsSyncAppointment = false;
                modalref.componentInstance.isAddBooking = isAddBooking;
                modalref.componentInstance.isView = this.isView;
                modalref.componentInstance.dealerName = this.dealerName;
                modalref.componentInstance.mechanicEfficiency = appointment.mechanicEfficiency;
                modalref.componentInstance.calendarNumber = this.calendarNumber;
                modalref.componentInstance.serviceDetail = this.serviceDetail;

                if (this.features?.length > 0) {
                    modalref.componentInstance.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
                    modalref.componentInstance.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
                }
                modalref.componentInstance.saveAppointmentBooking = async (mechanicPlanningViewModel: SaveAppointmentPlanning) => {
                    this.spinner.show();
                    mechanicPlanningViewModel.appointmentId = isAddBooking ? this.appointmentId : mechanicPlanningViewModel.appointmentId;
                    mechanicPlanningViewModel.mechanicId = isAddBooking ? pId : mechanicPlanningViewModel.mechanicId;
                    mechanicPlanningViewModel.CalendarNumber = this.calendarNumber
                    let isBookingAllowed = false;
                    let isWARBookingAllowed = false;
                    if (this.daySchedulerViewModel.mechanics.length > 0) {
                        let plannedData = this.daySchedulerViewModel.mechanics.filter(x => x.mechanicId == pId);
                        let data = plannedData[0].bookedAppointmentList.filter(x => x.isReserved);
                        isBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTimeLocal, mechanicPlanningViewModel.endDateTimeLocal, data);
                        let WARPlannedData = plannedData[0].bookedAppointmentList.filter(x => x.isunplanned)
                        isWARBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTimeLocal, mechanicPlanningViewModel.endDateTimeLocal, WARPlannedData);
                    }
                    if (!isBookingAllowed && !isWARBookingAllowed) {
                        if (this.WoStatusId != fromEnums.WOStatus.Closed && this.WoStatusId != fromEnums.WOStatus.Invoiceready && this.WoStatusId != fromEnums.WOStatus.InvoicePaid && this.WoStatusId != fromEnums.WOStatus.Cancelled) {
                            if (new Date(mechanicPlanningViewModel.startDateTimeToCompare).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
                                if (mechanicPlanningViewModel.durationInMin > +(EnvSetting.ShiftTime)) {
                                    await this.appointmentPlanningService.saveSplitBooking(mechanicPlanningViewModel)
                                        .then((resp) => {
                                            this.spinner.hide();
                                            if (resp) {
                                                this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
                                                this.showAddBooking.emit(true);
                                                modalref.close();
                                            } else {
                                                this.toastr.error('lblTimeSlotClashing')
                                            }
                                        });
                                }
                                else {
                                    await this.appointmentPlanningService.saveAppointmentPlanning(mechanicPlanningViewModel)
                                        .then((response) => {
                                            this.spinner.hide();
                                            if (response) {
                                                const errorObject = response.responseObject.result;
                                                this.bookingErrorMessage(errorObject);
                                            } else {
                                                this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
                                                this.showAddBooking.emit(true);
                                                modalref.close();
                                            }
                                        });
                                }
                            }
                            else {
                                this.toastr.error(this.translate.instant("lblCanNotAddPlanningForPreviousDate"));
                            }
                        }
                    }
                    else {
                        event.preventDefault();
                        this.toastr.error(this.translate.instant("lblPlanningValidation"));
                    }
                    this.spinner.hide();
                }
            }
            else {
                event.preventDefault();
                this.toastr.error(this.translate.instant("lblPlanningValidation"));
            }
        }

    }

    BlockMechanic(event: Event, pId, pText, slotHour, selectedDate, boxNumber, appointment, isAddBooking) {
        if (this.openContextId && this.openContextId.length > 0) {
            let section = document.querySelector('.' + this.openContextId)
            if (section != null) {
                section.setAttribute('hidden', 'true')
            }
            this.contextmenu = false;
        }
        if (!appointment?.isReserved && !appointment?.isunplanned) {
            let compareDate = selectedDate;

            if (selectedDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
                const modalref = this.model.open(BlockMechanicComponent, { size: 'lg', windowClass: !isAddBooking && 'pop-wid1200' });
                modalref.componentInstance.mechanicName = pText;
                modalref.componentInstance.startDate = compareDate.setHours(slotHour, boxNumber);
                modalref.componentInstance.pId = pId;
                modalref.componentInstance.durationValue = undefined;
                modalref.componentInstance.unavailableDates = undefined;
                modalref.componentInstance.endTime = undefined;
                modalref.componentInstance.dealerId = this.dealerId;
                modalref.componentInstance.mechanicStartTime = slotHour;
                modalref.componentInstance.dealerWorkingHours = this.appointmentPlanningService.dealerWorkingHours;
                modalref.componentInstance.dealerHolidays = this.appointmentPlanningService.dealerHolidays;
                modalref.componentInstance.isServicesAdded = this.appointmentPlanningService.isServicesAdded;
                modalref.componentInstance.calenderStartDate = Utility.GetFormattedDate(new Date());
                modalref.componentInstance.totalTimeDuration = this.duration;
                modalref.componentInstance.boxNumber = boxNumber;
                modalref.componentInstance.moduleId = Enums.ModuleNames.Appointment;
                modalref.componentInstance.integrationWithDMS = false;
                modalref.componentInstance.realtimeDmsSyncAppointment = false;
                modalref.componentInstance.isAddBooking = isAddBooking;
                modalref.componentInstance.isView = this.isView;
                modalref.componentInstance.dealerName = this.dealerName;
                modalref.componentInstance.mechanicEfficiency = appointment.mechanicEfficiency;
                modalref.componentInstance.calendarNumber = this.calendarNumber;
                modalref.componentInstance.serviceDetail = this.serviceDetail;

                if (this.features?.length > 0) {
                    modalref.componentInstance.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
                    modalref.componentInstance.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
                }
                modalref.componentInstance.saveAppointmentBooking = async (mechanicPlanningViewModel: SaveAppointmentPlanning) => {
                    this.spinner.show();
                    mechanicPlanningViewModel.appointmentId = isAddBooking ? this.appointmentId : mechanicPlanningViewModel.appointmentId;
                    mechanicPlanningViewModel.mechanicId = isAddBooking ? pId : mechanicPlanningViewModel.mechanicId;
                    mechanicPlanningViewModel.CalendarNumber = this.calendarNumber
                    let isBookingAllowed = false;
                    let isWARBookingAllowed = false;
                    if (this.daySchedulerViewModel.mechanics.length > 0) {
                        let plannedData = this.daySchedulerViewModel.mechanics.filter(x => x.mechanicId == pId);
                        let data = plannedData[0].bookedAppointmentList.filter(x => x.isReserved);
                        isBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTimeLocal, mechanicPlanningViewModel.endDateTimeLocal, data);
                        let WARPlannedData = plannedData[0].bookedAppointmentList.filter(x => x.isunplanned)
                        isWARBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTimeLocal, mechanicPlanningViewModel.endDateTimeLocal, WARPlannedData);
                    }
                    if (!isBookingAllowed && !isWARBookingAllowed) {
                        if (this.WoStatusId != fromEnums.WOStatus.Closed && this.WoStatusId != fromEnums.WOStatus.Invoiceready && this.WoStatusId != fromEnums.WOStatus.InvoicePaid && this.WoStatusId != fromEnums.WOStatus.Cancelled) {
                            if (new Date(mechanicPlanningViewModel.startDateTimeToCompare).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
                                
                                    await this.appointmentPlanningService.saveMechanicBlockedSlot(mechanicPlanningViewModel)
                                        .then((response) => {
                                            this.spinner.hide();
                                            if (response) {
                                                const errorObject = response.responseObject.result;
                                                this.bookingErrorMessage(errorObject);
                                            } else {
                                                this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
                                                this.showAddBooking.emit(true);
                                                modalref.close();
                                            }
                                        });
                            }
                            else {
                                this.toastr.error(this.translate.instant("lblCanNotAddPlanningForPreviousDate"));
                            }
                        }
                    }
                    else {
                        event.preventDefault();
                        this.toastr.error(this.translate.instant("lblPlanningValidation"));
                    }
                    this.spinner.hide();
                }
            }
            else {
                event.preventDefault();
                this.toastr.error(this.translate.instant("lblPlanningValidation"));
            }
        }

    }
    async ViewAppointment(event: any, data: any) {
         if (this.appointmentId !== data.appointmentId) {
            this.multiStackPopupService.OpenAppointment(data.appointmentId,false,true);
         }
         else
         {
            this.toastr.error(this.translate.instant("lblAlreadyInCurrentappointment"));
         }
    }
    processBookingData(data, mechanic, isReadOnly) {
        let dates = mechanic.bookedAppointmentList.filter(x => x.appointmentId === data?.appointmentId);
        let appointment = dates.filter(x => x.appointmentStartTime.getHours() == data.slotStartTime?.getHours());
        this.dragPlanningBookingId = appointment?.slice(-1)[0]?.bookingId;
        this.dragData = data;
        this.dragMechanicData = mechanic;
        this.isReadOnly = isReadOnly;
    }

    CutPlanning(event: any, mechanic: any, data: any, _slotHour) {
        this.isClickOnCut = true;
        if (!data?.isReserved && !data?.isunplanned && !this.isReadOnly) {
            this.processBookingData(data, mechanic, false)
        }
        else if (!data?.isReserved && !data?.isunplanned && this.isReadOnly) {
            this.processBookingData(data, mechanic, true)
        }
        else {
            event.preventDefault();
        }
    }
    PastePlanning(event, _mechanic, appointment, _slotHour) {
        this.isClickOnCut = false;
        this.spinner.show();
        this.features = this.secureStorage.getKeyData('feature');
        let planningAllowOnLeave, available;
        if (this.features?.length > 0) {
            planningAllowOnLeave = this.features.find(x => x.featureCode === Enums.FeatureCode.AllowPlanningOnLeave)?.isActive;
        }
        if (planningAllowOnLeave) {
            available = appointment?.isAvailable && !appointment?.isOnLunch && !appointment?.isOnBreak1 &&
            !appointment?.isOnBreak2 && appointment?.isSlotInMechanicShift && !appointment?.previousDate;
            if (!this.dragData.isNotAvailable && !this.dragData.isLeave && (appointment?.isNotAvailable || appointment?.isLeave)) {
                let modelHeadermsg = this.translate.instant("lblConfirmation");
                let modelBodymsg = this.translate.instant("lblAssociatePlanningOnLeave");
                const modalRef = this.modalService.open(NgbdModalContent);
                modalRef.componentInstance.modelHeader = modelHeadermsg;
                modalRef.componentInstance.modelBody = modelBodymsg;
                modalRef.result.then((_result) => {
                    // This is intentional
                }, (reason) => {
                    this.popupCloseResult = this.getDismissReason(reason);
                    if (this.popupCloseResult) {
                        this.onPastePlanningEfficiencyCalculation(appointment, event, available,_mechanic);
                    }
                });
                this.spinner.hide();
            }
            else {
                this.onPastePlanningEfficiencyCalculation(appointment, event, available,_mechanic);
                this.spinner.hide();
            }
        }
        else {
            available = !appointment?.isLeave && !appointment?.isOnLunch && !appointment?.isOnBreak1 &&
            !appointment?.isOnBreak2 && !appointment?.isNotAvailable && appointment?.isSlotInMechanicShift && !appointment?.previousDate;
            this.onPastePlanningEfficiencyCalculation(appointment, event, available,_mechanic);
            this.spinner.hide();
        }

    }

    onPastePlanningEfficiencyCalculation(appointment, event, available, pasteMechanicData) {
        if (this.dragMechanicData?.mechanicEfficiency == null || this.dragMechanicData?.mechanicEfficiency == undefined || 
                 pasteMechanicData?.mechanicEfficiency == null || pasteMechanicData?.mechanicEfficiency == undefined) {
            this.onPastePlanning(appointment, event, available);
        }
        else if (this.dragMechanicData?.mechanicEfficiency == pasteMechanicData?.mechanicEfficiency) {
            this.onPastePlanning(appointment, event, available);
        }
        else {
            let recalculatedDuration = (this.dragData?.duration * this.dragMechanicData?.mechanicEfficiency) / pasteMechanicData?.mechanicEfficiency;
            recalculatedDuration = Math.ceil(recalculatedDuration);
            if(recalculatedDuration < 15)
                recalculatedDuration = 15;
            this.onChangePlanningPopUp(pasteMechanicData,recalculatedDuration,appointment, event, available,false, null);
        }
    }

    onPastePlanning(appointment, event, available) {
        let bookingId = this.dragPlanningBookingId;
        this.spinner.show();
        if (new Date(appointment?.slotStartTime).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
            if (available) {
                appointment.slotEndTime = new Date(JSON.parse(JSON.stringify(appointment?.slotStartTime)));
                appointment?.slotEndTime.setMinutes(appointment?.slotStartTime.getMinutes() + this.dragData?.duration);
                let mechanicPlanningViewModel: SaveAppointmentPlanning = {
                    appointmentId: this.dragData?.appointmentId !== undefined ? this.dragData?.appointmentId : this.appointmentId,
                    mechanicId: appointment?.mechanicId,
                    startDateTime: appointment?.slotStartTime.toUTCString(),
                    endDateTime: appointment?.slotEndTime.toUTCString(),
                    durationInMin: this.dragData?.duration,
                    startDateTimeLocal: this.datePipe.transform(appointment?.slotStartTime, 'yyyy-MM-dd HH:mm:ss'),
                    endDateTimeLocal: this.datePipe.transform(appointment?.slotEndTime, 'yyyy-MM-dd HH:mm:ss'),
                    bookingId: bookingId ?? this.dragPlanningBookingId,
                    dragMechanicId: this.dragData?.mechanicId,
                    dragMechanicBookingId: this.dragPlanningBookingId,
                    isdrag: true,
                    endDateTimeToCompare: appointment?.slotEndTime.toUTCString(),
                    startDateTimeToCompare: appointment?.slotStartTime.toUTCString(),
                    moduleId: Enums.ModuleNames.Appointment,
                    integrationWithDMS: false,
                    realtimeDmsSyncAppointment: false,
                    CalendarNumber: this.calendarNumber
                };
                if (this.daySchedulerViewModel.mechanics.length > 0) {
                    let plannedData = this.daySchedulerViewModel.mechanics.filter(x => x.mechanicId == appointment?.mechanicId);
                    let data = plannedData[0].bookedAppointmentList.filter(x => x.isReserved)
                    let isBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, data)
                    let WARPlannedData = plannedData[0].bookedAppointmentList.filter(x => x.isunplanned)
                    let isWARBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, WARPlannedData)
                }

                if (mechanicPlanningViewModel.bookingId > 0) {

                    this.appointmentPlanningService.UpdateAppointmentPlanningTime(mechanicPlanningViewModel)
                        .then((response) => {
                            this.handleUpdateResponse(response);
                        });

                    this.dragPlanningBookingId = 0;
                    this.contextmenu = false;
                    this.spinner.hide();
                }
                else {
                    this.appointmentPlanningService.saveAppointmentPlanning(mechanicPlanningViewModel)
                        .then((response) => {
                            this.handleSaveResponse(response)
                        });
                    this.dragPlanningBookingId = 0;
                    this.contextmenu = false;
                    this.spinner.hide();
                }
                this.spinner.hide();
            }
        }
        else {
            this.toastr.error(this.translate.instant("lblCanNotUpdatePlanningForPreviousDate"));
        }
        this.dragPlanningBookingId = 0;
        this.contextmenu = false;
        this.spinner.hide();
        if (this.openContextId && this.openContextId.length > 0) {
            let section = document.querySelector('.' + this.openContextId)
            if (section != null) {
                section.setAttribute('hidden', 'true')
            }
        }
        this.contextmenu = false;
        event.preventDefault()
        event.stopPropagation();
        return false;
    }

    handleUpdateResponse(response,) {
        this.showAddBooking.emit(true);
        this.spinner.hide();
        if (response) {
            const errorObject = response.responseObject.result;
            this.bookingErrorMessage(errorObject);
            this.stopPropagationAndHideSpinner(event)
        } else {
            this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
        }
    }

    handleSaveResponse(response) {
        if (response) {
            this.spinner.hide();
            const errorObject = response.responseObject.result;
            this.bookingErrorMessage(errorObject);
            this.preventDefaultStopPropagationAndHideSpinner(event)
            return false;

        } else {
            this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
            this.showAddBooking.emit(true);
        }
    }
    stopPropagationAndHideSpinner(event) {
        event.stopPropagation();
        this.spinner.hide();
    }
    preventDefaultStopPropagationAndHideSpinner(event) {
        event.preventDefault();
        event.stopPropagation();
        this.spinner.hide();
    }
    checkReserveSlotAvailability(startTime, endTime, reserveSlot) {
        let offTime: boolean = false;
        if (reserveSlot?.length > 0) {
            for (let value of reserveSlot) {
                if (new Date(startTime).getTime() >= value.appointmentStartTime.getTime() && new Date(startTime).getTime() < value.appointmentEndTime.getTime()) {
                    offTime = true;
                    break;
                }
                if (new Date(endTime).getTime() > value.appointmentStartTime.getTime() && new Date(endTime).getTime() < value.appointmentEndTime.getTime()) {
                    offTime = true;
                    break;
                }
            }
        }
        return offTime;
    }
    bookingErrorMessage(errorObject) {
        switch (errorObject.errorCode) {
            case '1':
                this.toastr.error(this.translate.instant("lblTimeSlotClashing"));
                break;
            case '2':
                this.toastr.error(this.translate.instant("lblDealerNotWorking"));
                break;
            case '3':
                this.toastr.error(this.translate.instant("lblHolidayDay"));
                break;
            case '4':
                this.toastr.error(this.translate.instant("lblMechanicLeave"));
                break;
            case '5':
                this.toastr.error(this.translate.instant("lblBookingClashWithLunch"));
                break;
            case '6':
                this.toastr.error(this.translate.instant("lblNoDealerShiftTime"));
                break;
            case '7':
                this.toastr.error(this.translate.instant("lblMechanicNotAvailable"));
                break;
            case '8':
                this.toastr.error(this.translate.instant("lblPlanningCannotBeChanged"));
                break;
            default:
                this.toastr.error(fromEnums.ToastrMessages.NoMechanicAvailable);
                break;
        }
    }
    public scrollTo(scrollTop: number): void {
        if (this.plannerBody?.nativeElement) {
            this.isSyncingScroll = true;
            this.plannerBody.nativeElement.scrollTop = scrollTop;
        }
    }

    onScroll(element: HTMLElement) {
        this.scrollLeft = element.scrollLeft;
        if (this.isSyncingScroll) {
            this.isSyncingScroll = false;
            return;
        }
        this.onScrollPlanning.emit({
            scrollTop: element.scrollTop,
            scrollLeft: element.scrollLeft
        });
        if (this.openContextId && this.openContextId.length > 0) {
            let section = document.querySelector('.' + this.openContextId)
            if (section != null) {
                section.setAttribute('hidden', 'true')
            }
        }
        this.contextmenu = false;
    }
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (event.type == 'click') {
            if (this.openContextId && this.openContextId.length > 0) {
                let section = document.querySelector('.' + this.openContextId)
                if (section != null) {
                    section.setAttribute('hidden', 'true')
                }
            }
            this.contextmenu = false;
        }

    }
    drag(event: any, mechanic: any, data: any, slotHour) {
        if (!data?.isReserved && !data?.isunplanned && !data?.isBlocked && !(data?.workOrderStatus == fromEnums.WOStatusName.InvoicePaid || data?.workOrderStatus == fromEnums.WOStatusName.Cancelled || data?.workOrderStatus == fromEnums.WOStatusName.Closed)) {
            let dates = mechanic.bookedAppointmentList.filter(x => x.appointmentId === data?.appointmentId)
            let appointment = dates.filter(x => x.appointmentStartTime.getHours() === slotHour)
            this.dragPlanningBookingId = appointment.filter(x => x.appointmentStartTime.toString() == data?.slotStartTime.toString())[0]?.bookingId;
            event.dataTransfer.setData("text", event.target.id);
            this.dragData = data;
            this.dragMechanicData = mechanic;
        }
        else {
            event.preventDefault();
        }
    }
    async onDrop(event, mechanic, appointment, slotHour) {
        this.spinner.show();
        event.target.classList.remove('drag-hover');
        let date = mechanic.bookedAppointmentList.filter(x => x.appointmentId === appointment?.appointmentId)
        let appointments = date.filter(x => x.appointmentStartTime.getHours() === slotHour)
        this.features = this.secureStorage.getKeyData('feature');
        let planningAllowOnLeave; let available;
        if (this.features?.length > 0) {
            planningAllowOnLeave = this.features.find(x => x.featureCode === Enums.FeatureCode.AllowPlanningOnLeave)?.isActive;
        }

        if (planningAllowOnLeave) {
            available = !appointment?.isOnLunch && !appointment?.isOnBreak1 &&
            !appointment?.isOnBreak2 && appointment?.isSlotInMechanicShift && !appointment?.previousDate;
            if (!this.dragData.isNotAvailable && !this.dragData.isLeave && (appointment?.isNotAvailable || appointment?.isLeave)) {
                let modelHeadermsg = this.translate.instant("lblConfirmation");
                let modelBodymsg = this.translate.instant("lblAssociatePlanningOnLeave");
                const modalRef = this.modalService.open(NgbdModalContent);
                modalRef.componentInstance.modelHeader = modelHeadermsg;
                modalRef.componentInstance.modelBody = modelBodymsg;
                modalRef.result.then((_result) => {
                    // This is intentional
                }, (reason) => {
                    this.popupCloseResult = this.getDismissReason(reason);
                    if (this.popupCloseResult) {
                        this.onDropPlanningEfficiencyCalculation(appointments, appointment, event, available,mechanic);
                    }
                });
            }
            else {
                this.onDropPlanningEfficiencyCalculation(appointments, appointment, event, available,mechanic);
            }

        }
        else {
            available = !appointment?.isLeave && !appointment?.isOnLunch && !appointment?.isOnBreak1 &&
            !appointment?.isOnBreak2 && !appointment?.isNotAvailable && appointment?.isSlotInMechanicShift && !appointment?.previousDate;
            this.onDropPlanningEfficiencyCalculation(appointments, appointment, event, available,mechanic);
        }
        this.spinner.hide();
    }

    onDropPlanningEfficiencyCalculation(appointments, appointment, event, available, dropMechanicData:any) {
        if (this.dragMechanicData?.mechanicEfficiency == null || this.dragMechanicData?.mechanicEfficiency == undefined || 
                 dropMechanicData?.mechanicEfficiency == null || dropMechanicData?.mechanicEfficiency == undefined) {
            this.onDropPlanning(appointments, appointment, event, available);
        }
        else if (this.dragMechanicData?.mechanicEfficiency == dropMechanicData?.mechanicEfficiency) {
            this.onDropPlanning(appointments, appointment, event, available);
        }
        else {
            let recalculatedDuration = (this.dragData?.duration * this.dragMechanicData?.mechanicEfficiency) / dropMechanicData?.mechanicEfficiency;
            recalculatedDuration = Math.ceil(recalculatedDuration);
            if(recalculatedDuration < 15)
                recalculatedDuration = 15;
            this.onChangePlanningPopUp(dropMechanicData,recalculatedDuration,appointment, event, available,true, appointments);
        }
    }

    onChangePlanningPopUp(mechanicData:any,recalculatedDuration:any,appointment:any, event:any, available:any,isDropPlanning:any,appointments:any = null){
        let modelHeadermsg = this.translate.instant("lblConfirmation");
        let bodyMessage = this.translate.instant("lblConfirmChangePlanningMechanic");
        bodyMessage = bodyMessage.replace("{OldMechanicName}", this.dragMechanicData?.mechanicName)
        bodyMessage = bodyMessage.replace("{OldMechanicEfficiency}", this.dragMechanicData?.mechanicEfficiency)
        bodyMessage = bodyMessage.replace("{NewMechanicName}", mechanicData?.mechanicName)
        bodyMessage = bodyMessage.replace("{NewMechanicEfficiency}", mechanicData?.mechanicEfficiency)
        bodyMessage = bodyMessage.replaceAll(String.raw`\n`, '\n');
        let modelBodymsg = bodyMessage;
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
            // This is intentional
        }, (reason) => {
            this.popupCloseResult = this.getDismissReason(reason);
            if (this.popupCloseResult) {
                this.dragData.duration = recalculatedDuration;
                if (isDropPlanning) {
                    this.onDropPlanning(appointments, appointment, event, available);
                }
                else {
                    this.onPastePlanning(appointment, event, available);
                }
            } else if (isDropPlanning) {
                this.onDropPlanning(appointments, appointment, event, available);
            }
            else {
                this.onPastePlanning(appointment, event, available);
            }
        });
    }
    
    onDropPlanning(appointments, appointment, event, available) 
    {
        let bookingId = appointments?.bookingId;
        if (!appointment?.isAvailable) {
            if (this.dragPlanningTime?.length > 0) {
                let time = this.dragPlanningTime?.split('_');
                appointment?.slotStartTime.setHours(+time[2], +time[1], 0)
            }
        }
        if ((appointments[0]?.appointmentStartTime.toUTCString() != appointment?.slotStartTime.toUTCString())) {
            this.spinner.show();
            if (available) {
                appointment.slotEndTime = new Date(JSON.parse(JSON.stringify(appointment?.slotStartTime)));
                appointment?.slotEndTime.setMinutes(appointment?.slotStartTime.getMinutes() + this.dragData?.duration);
                let mechanicPlanningViewModel: SaveAppointmentPlanning = {
                    appointmentId: this.dragData?.appointmentId,
                    mechanicId: appointment?.mechanicId,
                    startDateTime: appointment?.slotStartTime.toUTCString(),
                    endDateTime: appointment?.slotEndTime.toUTCString(),
                    durationInMin: this.dragData?.duration, //appointment
                    startDateTimeLocal: this.datePipe.transform(appointment?.slotStartTime, 'yyyy-MM-dd HH:mm:ss'),
                    endDateTimeLocal: this.datePipe.transform(appointment?.slotEndTime, 'yyyy-MM-dd HH:mm:ss'),
                    bookingId: bookingId ?? this.dragPlanningBookingId,
                    dragMechanicId: this.dragData?.mechanicId,
                    dragMechanicBookingId: this.dragPlanningBookingId,
                    isdrag: true,
                    endDateTimeToCompare: appointment?.slotEndTime.toUTCString(),
                    startDateTimeToCompare: appointment?.slotStartTime.toUTCString(),
                    moduleId: Enums.ModuleNames.Appointment,
                    integrationWithDMS: false,
                    realtimeDmsSyncAppointment: false,
                    CalendarNumber: this.calendarNumber
                };

                this.features = this.secureStorage.getKeyData('feature');
                if (this.features?.length > 0) {
                    mechanicPlanningViewModel.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
                    mechanicPlanningViewModel.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
                }
                if (this.daySchedulerViewModel.mechanics.length > 0) {
                    let plannedData = this.daySchedulerViewModel.mechanics.filter(x => x.mechanicId == appointment?.mechanicId);
                    let data = plannedData[0].bookedAppointmentList.filter(x => x.isReserved)
                    this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, data)
                    let WARPlannedData = plannedData[0].bookedAppointmentList.filter(x => x.isunplanned)
                    this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, WARPlannedData)
                }

                if (mechanicPlanningViewModel.bookingId > 0) {
                    if (new Date(mechanicPlanningViewModel.startDateTimeToCompare).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) {
                        let data = event.dataTransfer.getData("text");
                        if (data?.length > 0 && appointment?.isAvailable) {
                            event.target.appendChild(document.getElementById(data));
                        }
                        this.appointmentPlanningService.UpdateAppointmentPlanningTime(mechanicPlanningViewModel)
                            .then((response) => {
                                this.showAddBooking.emit(true);
                                this.spinner.hide();
                                if (response) {
                                    const errorObject = response.responseObject.result;
                                    this.bookingErrorMessage(errorObject);
                                    event.stopPropagation();
                                    this.spinner.hide();
                                } else {
                                    this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
                                }
                                this.dragPlanningBookingId = 0;
                            });
                    }

                    else {
                        this.toastr.error(this.translate.instant("lblCanNotUpdatePlanningForPreviousDate"));
                        event.preventDefault()
                        event.stopPropagation();
                        this.spinner.hide();
                    }
                    this.spinner.hide();
                }
                else {
                    let data = event.dataTransfer.getData("text");
                    event.target.appendChild(document.getElementById(data));
                    this.appointmentPlanningService.saveAppointmentPlanning(mechanicPlanningViewModel)
                        .then((resps) => {
                            this.spinner.hide();
                            if (resps) {
                                const errorObject = resps.responseObject.result;
                                this.bookingErrorMessage(errorObject);
                                event.preventDefault();
                                event.stopPropagation();
                                this.spinner.hide();
                                return false;

                            } else {
                                this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
                                this.showAddBooking.emit(true);
                            }
                        });
                    this.spinner.hide();
                }
                this.spinner.hide();
            }
            else {
                if (new Date(appointment?.slotStartTime).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                    this.toastr.error(this.translate.instant("lblPlanningValidation"));
                }
                else {
                    this.toastr.error(this.translate.instant("lblSlotNotAvailable"));
                }
                this.spinner.hide();
            }
        }
        this.dragPlanningBookingId = 0;
        event.preventDefault()
        event.stopPropagation();
        return false;
    }
    onDragOver(event) {
        this.dragPlanningTime = event.currentTarget?.attributes['data-apt'];
        event.preventDefault()
    }
    dragenter(event, appointment: any) {
        //drag-hover
        if (!appointment?.isLeave && !appointment?.isOnLunch && !appointment?.isOnBreak1 &&
            !appointment?.isOnBreak2 && !appointment?.isNotAvailable && appointment?.isSlotInMechanicShift && !appointment?.previousDate) {
            event.target.classList.add('drag-hover');
            event.dataTransfer.dropEffect = "move";
            event.stopPropagation();
        }

    }
    dragleave(event, _slot: any) {
        event.target.classList.remove('drag-hover');
        event.stopPropagation();
    }
    PopUpClose(e: Event) {
        e.stopPropagation();
        this.isDisplayMouseHoverDetail = false;
        this.isDisplayMouseHoverId = null;
        this.isDisplayMouseHoverMechanicId = null;
    }
    async GetSlotClickDetails(tooltip, event, slotAppointment, index: number, mechanic, slotHour, _displayIndex: number) {
        if (this.openContextId && this.openContextId.length > 0) {
            let section = document.querySelector('.' + this.openContextId)
            if (section != null) {
                section.setAttribute('hidden', 'true')
            }
            this.contextmenu = false;
        }
        if (tooltip.isOpen()) {
            tooltip.close();
        } else {
            tooltip.open();
        }
        this.isDisplayMouseHoverDetail = false
        this.isDisplayMouseHoverId = slotHour;
        this.isDisplayMouseHoverMechanicId = mechanic.mechanicId;
        let dates = mechanic.bookedAppointmentList.filter(x => x.appointmentId === slotAppointment.appointmentId)
        dates = dates.filter(x => x.appointmentStartTime.getHours() === slotHour)

        let appointment = mechanic.bookedAppointmentList.find(x => x.appointmentId === slotAppointment.appointmentId);

        let isWARAppointment = appointment.isWARAppoinment || false;
     
        if(slotAppointment.appointmentId!=null){ 
            await this.appointmentService.getDemandDescription(slotAppointment.appointmentId, isWARAppointment).then((res) => {
                if(res && res.length > 0)
                {
                    this.appointmentDemands = res;
                }
            });
        }
        else{
            this.appointmentDemands = [];
        }
        let isAnyWarrantyDemand = this.appointmentDemands.some(x => x.isWarranty);
        this.appointmentSlotDetails = {
            appointmentId: slotAppointment.appointmentId,
            customerName: slotAppointment.customerName,
            licensePlate: slotAppointment.licensePlate,
            mechanicName: mechanic.mechanicName,
            mechanicId: mechanic.mechanicId,
            appointmentStartTime: dates[0].appointmentStartTime,
            appointmentEndTime: dates[0].appointmentEndTime,
            isDisplayMouseHoverDetail: true,
            workOrderNo: dates[0].workOrderNo,
            workOrderColor: slotAppointment.appointmentColor,
            brand: slotAppointment.brand,
            brandCode: slotAppointment.brandCode,
            appointmentDemands : this.appointmentDemands,
            isAnyWarrantyDemand : isAnyWarrantyDemand
        }
        this.isDisplayMouseHoverDetail = true;
        const popleft = event.pageX;
        const popupWidth = 360;
        this.idSpaceFromPlannerTopOffset = index * 40;
        this.idSpaceFromPlannerTopOffset = this.idSpaceFromPlannerTopOffset - this.plannerBody.nativeElement.scrollTop;

        if (popleft + popupWidth + 20 > window.innerWidth - 40) {
            this.slotDetailPosition = popleft - popupWidth - 10;
        } else {
            this.slotDetailPosition = event.pageX;
        }
    }

    OnResizing(event, slotAppointment) {
        const width = event.rectangle.width;
        slotAppointment.isResized = true;
        slotAppointment.resizeBarWidth = width;
    }
    OnResizeEnd(event, slotAppointment, slotHour, mechanic, selectedDate) {
        this.features = this.secureStorage.getKeyData('feature');
        let planningAllowOnLeave, available;
        if (this.features?.length > 0) {
            planningAllowOnLeave = this.features.find(x => x.featureCode === Enums.FeatureCode.AllowPlanningOnLeave)?.isActive;
        }
        if (planningAllowOnLeave) {
            available = !slotAppointment?.isReserved && !slotAppointment?.isunplanned;
        }
        else {
            available = !slotAppointment?.isReserved && !slotAppointment?.isunplanned && !slotAppointment?.isNotAvailable && !slotAppointment?.isLeave;
        }
        if (available) {
            if (selectedDate >= new Date().setHours(0, 0, 0, 0)) {
                let dates = mechanic.bookedAppointmentList.filter(x => x.bookingId === slotAppointment.bookingId)
                dates = dates.filter(x => x.appointmentStartTime.getHours() === slotHour)
                let milisecond = (dates[0].appointmentEndTime.getTime() - dates[0].appointmentStartTime.getTime())
                let minutes = ((milisecond / 1000) / 60);
                // Set booking slot start time and end time
                const slotStartTime = new Date(dates[0].appointmentStartTime);
                const slotEndTime = new Date(dates[0].appointmentEndTime);
                let extendedDuration = ((Math.round((event.rectangle.width / this.singleSlotArea)) * 15) - minutes);
                if (event.edges.left !== undefined) {
                    let extendedDurationForLeft = this.round(event.edges.left / 2);
                    slotStartTime.setMinutes(slotStartTime.getMinutes() + extendedDurationForLeft);
                    let time = this.findTime(slotStartTime.getMinutes());
                    slotStartTime.setMinutes(time);
                }
                else {
                    slotEndTime.setMinutes(slotEndTime.getMinutes() + extendedDuration);
                }
                if (new Date(slotAppointment.date.toDateString() + ' ' + Utility.ConvertToTimeFormat(mechanic.shiftStartTime)) <= slotStartTime) {

                    if (minutes !== extendedDuration || (event.edges.left !== undefined && event.edges.left < -14) || (event.edges.left !== undefined && event.edges.left > 14) || (event.edges.right !== undefined && event.edges.right < -14) || (event.edges.right !== undefined && event.edges.right > 14)) {
                        // Set current selected date and current selected date end time
                        let shiftEndTime = this.daySchedulerViewModel.mechanics?.filter(x => x.mechanicId == slotAppointment.mechanicId)[0].shiftEndTime;
                        let shiftEnd = Utility.ConvertToTimeFormat(shiftEndTime)?.split(":")
                        let scheduleSelectedDate = new Date(this.daySchedulerViewModel.date);
                        let scheduleDateEndtime = new Date(this.daySchedulerViewModel.date);
                        scheduleDateEndtime = new Date(new Date(scheduleDateEndtime).setHours(+shiftEnd[0], +shiftEnd[1], +shiftEnd[2]))
                        this.daySchedulerViewModel.endHour = this.daySchedulerViewModel.endHour ?? 0;
                        scheduleDateEndtime.setMinutes(scheduleDateEndtime.getMinutes() + (this.daySchedulerViewModel.endHour * 60));
                        // check if booking slot increased more than day range
                        if (slotEndTime > scheduleDateEndtime) {
                            const startMins = slotStartTime.getHours() * 60 + slotStartTime.getMinutes();
                            const bookingSlotEndDate = new Date(slotEndTime.getFullYear(), slotEndTime.getMonth(), slotEndTime.getDate(), 0, 0, 0, 0);
                            let endMins;
                            if (bookingSlotEndDate > scheduleSelectedDate) {
                                endMins = 1440;
                            } else {
                                endMins = scheduleDateEndtime.getHours() * 60 + scheduleDateEndtime.getMinutes();
                            }
                            extendedDuration = endMins - startMins;
                        }
                        this.SetSingleSlotArea();
                        let dates = mechanic.bookedAppointmentList.filter(x => x.bookingId === slotAppointment.bookingId)
                        let appointment = dates.filter(x => x.appointmentStartTime.getHours() === slotHour)
                        this.dragPlanningBookingId = appointment[0]?.bookingId;
                        slotAppointment.isResized = true;
                        slotAppointment.resizeBarWidth = event.rectangle.width - 4;
                        let mechanicPlanningViewModel: SaveAppointmentPlanning = {
                            appointmentId: slotAppointment.appointmentId,
                            mechanicId: slotAppointment.mechanicId,
                            startDateTime: slotStartTime.toUTCString(),
                            endDateTime: slotEndTime.toUTCString(),
                            durationInMin: (extendedDuration + minutes),
                            startDateTimeLocal: this.datePipe.transform(slotStartTime, 'yyyy-MM-dd HH:mm:ss'),
                            endDateTimeLocal: this.datePipe.transform(slotEndTime, 'yyyy-MM-dd HH:mm:ss'),
                            bookingId: appointment[0]?.bookingId,
                            endDateTimeToCompare: slotEndTime.toUTCString(),
                            startDateTimeToCompare: slotStartTime.toUTCString(),
                            isdrag: true,
                            dragMechanicId: slotAppointment?.mechanicId,
                            dragMechanicBookingId: this.dragPlanningBookingId,
                            moduleId: Enums.ModuleNames.Appointment,
                            integrationWithDMS: false,
                            realtimeDmsSyncAppointment: false,
                            CalendarNumber: this.calendarNumber
                        };

                        this.features = this.secureStorage.getKeyData('feature');
                        if (this.features?.length > 0) {
                            mechanicPlanningViewModel.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
                            mechanicPlanningViewModel.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
                        }
                        let isBookingAllowed;
                        let isWARBookingAllowed;

                        if (this.daySchedulerViewModel.mechanics.length > 0) {
                            let plannedData = this.daySchedulerViewModel.mechanics.filter(x => x.mechanicId == slotAppointment.mechanicId);
                            let data = plannedData[0].bookedAppointmentList.filter(x => x.isReserved)
                            isBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, data)
                            let WARPlannedData = plannedData[0].bookedAppointmentList.filter(x => x.isunplanned)
                            isWARBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, WARPlannedData)
                        }

                        if (!isBookingAllowed && !isWARBookingAllowed) {
                            this.spinner.show();
                            this.appointmentPlanningService.UpdateAppointmentPlanningTime(mechanicPlanningViewModel)
                                .then((response) => {
                                    this.showAddBooking.emit(true);
                                    this.spinner.hide();
                                    if (response) {
                                        const errorObject = response.responseObject.result;
                                        this.bookingErrorMessage(errorObject);
                                    } else {
                                        this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
                                    }
                                }).finally(() => {
                                    this.spinner.hide();
                                });
                            this.dragPlanningBookingId = 0;
                        }
                        else {
                            this.toastr.error(this.translate.instant("lblCanNotUpdatePlanningForPreviousDate"));
                        }
                    }
                }
            }
            else {
                this.toastr.error(this.translate.instant("lblCanNotUpdatePlanningForPreviousDate"));
                event.preventDefault()
                event.stopPropagation();
                this.spinner.hide();
            }
        }
    }

    OnBlockMechanicResizeEnd(event, slotAppointment, slotHour, mechanic, selectedDate) {
        this.features = this.secureStorage.getKeyData('feature');
        let planningAllowOnLeave, available;
        if (this.features?.length > 0) {
            planningAllowOnLeave = this.features.find(x => x.featureCode === Enums.FeatureCode.AllowPlanningOnLeave)?.isActive;
        }
        if (planningAllowOnLeave) {
            available = !slotAppointment?.isReserved && !slotAppointment?.isunplanned;
        }
        else {
            available = !slotAppointment?.isReserved && !slotAppointment?.isunplanned && !slotAppointment?.isNotAvailable && !slotAppointment?.isLeave;
        }
        if (available) {
            if (selectedDate >= new Date().setHours(0, 0, 0, 0)) {
                let dates = mechanic.bookedAppointmentList.filter(x => x.bookingId === slotAppointment.bookingId)
                dates = dates.filter(x => x.appointmentStartTime.getHours() === slotHour)
                let milisecond = (dates[0].appointmentEndTime.getTime() - dates[0].appointmentStartTime.getTime())
                let minutes = ((milisecond / 1000) / 60);
                // Set booking slot start time and end time
                const slotStartTime = new Date(dates[0].appointmentStartTime);
                const slotEndTime = new Date(dates[0].appointmentEndTime);
                let extendedDuration = ((Math.round((event.rectangle.width / this.singleSlotArea)) * 15) - minutes);
                if (event.edges.left !== undefined) {
                    let extendedDurationForLeft = this.round(event.edges.left / 2);
                    slotStartTime.setMinutes(slotStartTime.getMinutes() + extendedDurationForLeft);
                    let time = this.findTime(slotStartTime.getMinutes());
                    slotStartTime.setMinutes(time);
                }
                else {
                    slotEndTime.setMinutes(slotEndTime.getMinutes() + extendedDuration);
                }
                if (new Date(slotAppointment.date.toDateString() + ' ' + Utility.ConvertToTimeFormat(mechanic.shiftStartTime)) <= slotStartTime) {

                    if (minutes !== extendedDuration || (event.edges.left !== undefined && event.edges.left < -14) || (event.edges.left !== undefined && event.edges.left > 14) || (event.edges.right !== undefined && event.edges.right < -14) || (event.edges.right !== undefined && event.edges.right > 14)) {
                        // Set current selected date and current selected date end time
                        let shiftEndTime = this.daySchedulerViewModel.mechanics?.filter(x => x.mechanicId == slotAppointment.mechanicId)[0].shiftEndTime;
                        let shiftEnd = Utility.ConvertToTimeFormat(shiftEndTime)?.split(":")
                        let scheduleSelectedDate = new Date(this.daySchedulerViewModel.date);
                        let scheduleDateEndtime = new Date(this.daySchedulerViewModel.date);
                        scheduleDateEndtime = new Date(new Date(scheduleDateEndtime).setHours(+shiftEnd[0], +shiftEnd[1], +shiftEnd[2]))
                        this.daySchedulerViewModel.endHour = this.daySchedulerViewModel.endHour ?? 0;
                        scheduleDateEndtime.setMinutes(scheduleDateEndtime.getMinutes() + (this.daySchedulerViewModel.endHour * 60));
                        // check if booking slot increased more than day range
                        if (slotEndTime > scheduleDateEndtime) {
                            const startMins = slotStartTime.getHours() * 60 + slotStartTime.getMinutes();
                            const bookingSlotEndDate = new Date(slotEndTime.getFullYear(), slotEndTime.getMonth(), slotEndTime.getDate(), 0, 0, 0, 0);
                            let endMins;
                            if (bookingSlotEndDate > scheduleSelectedDate) {
                                endMins = 1440;
                            } else {
                                endMins = scheduleDateEndtime.getHours() * 60 + scheduleDateEndtime.getMinutes();
                            }
                            extendedDuration = endMins - startMins;
                        }
                        this.SetSingleSlotArea();
                        let dates = mechanic.bookedAppointmentList.filter(x => x.bookingId === slotAppointment.bookingId)
                        let appointment = dates.filter(x => x.appointmentStartTime.getHours() === slotHour)
                        this.dragPlanningBookingId = appointment[0]?.bookingId;
                        slotAppointment.isResized = true;
                        slotAppointment.resizeBarWidth = event.rectangle.width - 4;
                        let mechanicPlanningViewModel: SaveAppointmentPlanning = {
                            appointmentId: slotAppointment.appointmentId,
                            mechanicId: slotAppointment.mechanicId,
                            startDateTime: slotStartTime.toUTCString(),
                            endDateTime: slotEndTime.toUTCString(),
                            durationInMin: (extendedDuration + minutes),
                            startDateTimeLocal: this.datePipe.transform(slotStartTime, 'yyyy-MM-dd HH:mm:ss'),
                            endDateTimeLocal: this.datePipe.transform(slotEndTime, 'yyyy-MM-dd HH:mm:ss'),
                            bookingId: appointment[0]?.bookingId,
                            endDateTimeToCompare: slotEndTime.toUTCString(),
                            startDateTimeToCompare: slotStartTime.toUTCString(),
                            isdrag: true,
                            dragMechanicId: slotAppointment?.mechanicId,
                            dragMechanicBookingId: this.dragPlanningBookingId,
                            moduleId: Enums.ModuleNames.Appointment,
                            integrationWithDMS: false,
                            realtimeDmsSyncAppointment: false,
                            CalendarNumber: this.calendarNumber
                        };

                        this.features = this.secureStorage.getKeyData('feature');
                        if (this.features?.length > 0) {
                            mechanicPlanningViewModel.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
                            mechanicPlanningViewModel.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
                        }
                        let isBookingAllowed;
                        let isWARBookingAllowed;

                        if (this.daySchedulerViewModel.mechanics.length > 0) {
                            let plannedData = this.daySchedulerViewModel.mechanics.filter(x => x.mechanicId == slotAppointment.mechanicId);
                            let data = plannedData[0].bookedAppointmentList.filter(x => x.isReserved)
                            isBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, data)
                            let WARPlannedData = plannedData[0].bookedAppointmentList.filter(x => x.isunplanned)
                            isWARBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, WARPlannedData)
                        }

                        if (!isBookingAllowed && !isWARBookingAllowed) {
                            this.spinner.show();
                            this.appointmentPlanningService.UpdateMechanicBlockedSlot(mechanicPlanningViewModel)
                                .then((response) => {
                                    this.showAddBooking.emit(true);
                                    this.spinner.hide();
                                    if (response) {
                                        const errorObject = response.responseObject.result;
                                        this.bookingErrorMessage(errorObject);
                                    } else {
                                        this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
                                    }
                                }).finally(() => {
                                    this.spinner.hide();
                                });
                            this.dragPlanningBookingId = 0;
                        }
                        else {
                            this.toastr.error(this.translate.instant("lblCanNotUpdatePlanningForPreviousDate"));
                        }
                    }
                }
            }
            else {
                this.toastr.error(this.translate.instant("lblCanNotUpdatePlanningForPreviousDate"));
                event.preventDefault()
                event.stopPropagation();
                this.spinner.hide();
            }
        }
    }

    public getbrand(): Promise<void> {
        return new Promise((resolve, _reject) => {
            this.brandService.getBrand().then((res) => {
                if (res) {
                    this.brandList = res;
                }
                resolve()
            });
        })
    }

    onDeleteMechanicBooking(content, appointment) {
        this.features = this.secureStorage.getKeyData('feature');
        let takeReasonForDeletePlanning = false;
        if (this.features?.length > 0) {
            takeReasonForDeletePlanning = this.features.find(x => x.featureCode === Enums.FeatureCode.ReasonForDeletePlanning)?.isActive;
        }
        if (takeReasonForDeletePlanning) {
            this.DeleteMechanicBookingWithReason(content, appointment);
        }
        else {
            this.DeleteMechanicBookingWithOutReason(appointment);
        }
    }
    DeleteMechanicBookingWithReason(content, appointment) {
        this.bookingId = appointment.bookingId;
        this.deleteAppointmentId = appointment.appointmentId;
        this.modalService.open(content, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then(async (result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    async deleteMechanicBooking(appointment): Promise<void> {
        this.spinner.show();
        let intergrationWithDMS, realtimeDmsSyncAppointment, takeReasonForDeletePlanning = false;;
        this.features = this.secureStorage.getKeyData('feature');
        if (this.features?.length > 0) {
            intergrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
            realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
            takeReasonForDeletePlanning = this.features.find(x => x.featureCode === Enums.FeatureCode.ReasonForDeletePlanning)?.isActive;
        }
        let viewModel = {
            AppointmentId: 0,
            BookingId: 0,
            IntegrationWithDMS: intergrationWithDMS,
            RealtimeDmsSyncAppointment: realtimeDmsSyncAppointment,
            ModuleId: Enums.ModuleNames.Appointment,
            Reason: this.reasonForDelete
        }
        if (takeReasonForDeletePlanning) {
            viewModel.AppointmentId = this.deleteAppointmentId ? this.deleteAppointmentId : this.appointmentId;
            viewModel.BookingId = this.bookingId;
        }
        else {
            viewModel.AppointmentId = appointment.appointmentId ? appointment.appointmentId : this.appointmentId;
            viewModel.BookingId = appointment.bookingId;
        }
        if (viewModel.AppointmentId > 0 && viewModel.BookingId > 0) {
            await this.appointmentPlanningService.DeleteAppointmentPlanning(viewModel)
                .then((response) => {
                    if (response) {
                        const errorObject = response.responseObject.result;
                        if (errorObject.errorCode === fromEnums.ErrorCodes.ParamInvalid) {
                            this.toastr.error(fromEnums.ToastrMessages.ParamInvalid);
                        } else if (errorObject.errorCode === fromEnums.ErrorCodes.DataNotFound) {
                            this.toastr.error(fromEnums.ToastrMessages.NoMechanicAvailable);
                        }else if (errorObject.errorCode === fromEnums.ErrorCodes.InvalidIdCode) {
                            let errorMessage = this.translate.instant("lblMechanicIsInClockIn");
                            this.toastr.error(errorMessage);
                          }
                    } else {
                        this.toastr.success(fromEnums.ToastrMessages.MechanicBookingDeleted);
                        this.showAddBooking.emit(true);
                    }
                    this.spinner.hide();
                    this.reasonForDelete = '';
                    this.bookingId = 0;
                    this.deleteAppointmentId = 0;
                });
        }
    }

    DeleteMechanicBookingWithOutReason(appointment) {
        let modelHeadermsg = this.translate.instant("lblDelete");
        let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblPlanning"), false);
        const modalRef = this.model.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
            // This is intentional
        }, async (reason) => {
            const popupCloseResult = this.getDismissReason(reason);
            if (popupCloseResult) {
                await this.deleteMechanicBooking(appointment);
            }
        });
    }
    onDeleteMechanicBlockedSlot(appointment){
        let modelHeadermsg = this.translate.instant("lblDelete");
        let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblMechanicBlockedSlot"), false);
        const modalRef = this.model.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
            // This is intentional
        }, async (reason) => {
            const popupCloseResult = this.getDismissReason(reason);
            if (popupCloseResult) {
                await this.deleteMechanicBlockedSlot(appointment);
            }
        });
    }
    async deleteMechanicBlockedSlot(appointment): Promise<void> {
        let intergrationWithDMS, realtimeDmsSyncAppointment, takeReasonForDeletePlanning = false;
        this.features = this.secureStorage.getKeyData('feature');
        if (this.features?.length > 0) {
            intergrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
            realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
            takeReasonForDeletePlanning = this.features.find(x => x.featureCode === Enums.FeatureCode.ReasonForDeletePlanning)?.isActive;
        }
        let bookingId = 0;
        if (takeReasonForDeletePlanning) {
            bookingId = this.bookingId;
        }
        else {
            bookingId = appointment.bookingId;
        }
        if (bookingId > 0) {
            this.spinner.show();
            await this.appointmentPlanningService.DeleteBlockedMechanicSlot(bookingId)
                .then((response) => {
                    this.spinner.hide();
                    if (response) {
                        const errorObject = response.responseObject.result;
                        if (errorObject.errorCode === fromEnums.ErrorCodes.ParamInvalid) {
                            this.toastr.error(fromEnums.ToastrMessages.ParamInvalid);
                        } else if (errorObject.errorCode === fromEnums.ErrorCodes.DataNotFound) {
                            this.toastr.error(fromEnums.ToastrMessages.NoMechanicAvailable);
                        }
                    } else {
                        this.toastr.success(fromEnums.ToastrMessages.MechanicBlockingDeleted);
                        this.showAddBooking.emit(true);
                    }
                    this.spinner.hide();
                    this.reasonForDelete = '';
                    this.bookingId = 0;
                    this.deleteAppointmentId = 0;
                }, (err) => {
                    this.spinner.hide();
                }).finally(() => {
                    this.spinner.hide();
                });
        }
    }
    private round(x) {
        if (x % 5 == 0) {
            let number = (Math.floor(x / 5)) * 5;
            return this.findNumber(number)
        } else {
            let number = ((Math.floor(x / 5)) * 5) + 5;
            return this.findNumber(number)
        }
    }

    private findNumber(number) {
        let result;
        switch (number) {
            case 5:
                result = 0
                break;
            case 10:
                result = 15
                break;
            case 20:
                result = 15
                break;
            case 25:
                result = 30
                break;
            case 35:
                result = 30
                break;
            case 40:
                result = 45
                break;
            case 50:
                result = 45
                break;
            case 55:
                result = 60
                break;
            case -5:
                result = 0
                break;
            case -10:
                result = -15
                break;
            case -20:
                result = -15
                break;
            case -25:
                result = -30
                break;
            case -35:
                result = -30
                break;
            case -40:
                result = -45
                break;
            case -50:
                result = -45
                break;
            case -55:
                result = -60
                break;
            default:
                result = number
                break;
        }
        return result;
    }

    private findTime(time) {
        let result = 0;
        if (time > 0 && time <= 15) {
            result = 15;
        }
        else if (time > 15 && time <= 30) {
            result = 30;
        }
        else if (time > 30 && time <= 45) {
            result = 45;
        }
        else if (time > 45 && time <= 60) {
            result = 60;
        }
        return result;
    }
    getTitle(appointment) {
        return '';
    }

    showLeavePopup(event: MouseEvent, appointment: any) {
        if (appointment?.isOnBreak1 || appointment?.isOnBreak2) {
            const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
            const left = rect.right + 8 + 190 > window.innerWidth ? rect.left - 198 : rect.right + 8;
            this.leavePopupPos = { top: rect.top, left };
            this.leavePopupInfo = {
                leaveType: this.translate.instant(appointment.isOnBreak1 ? 'lblBreak1' : 'lblBreak2'),
                remark: '',
                colorCode: ''
            };
            this.leavePopupVisible = true;
            return;
        }
        if (!appointment?.isLeave || !this.mechanicLeaveTypesList?.length) return;
        const leaveType = this.mechanicLeaveTypesList.find(x => x.id === appointment.leaveOption);
        if (!leaveType) return;
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        const left = rect.right + 8 + 190 > window.innerWidth ? rect.left - 198 : rect.right + 8;
        this.leavePopupPos = { top: rect.top, left };
        this.leavePopupInfo = {
            leaveType: this.translate.instant(leaveType.leaveLabel),
            remark: appointment.Remark || '',
            colorCode: leaveType.colorCode || '#888'
        };
        this.leavePopupVisible = true;
    }

    hideLeavePopup() {
        this.leavePopupVisible = false;
        this.leavePopupInfo = null;
    }

    getSlotWidth(duration: number, isResized: boolean, resizeBarWidth: number): string {
        if (isResized) {
            return resizeBarWidth + 'px';
        }
        return (Math.ceil(duration / 15) * 30) + 'px';
    }

    getLeaveColorStyle(appointment: any): {[key: string]: string} {
        if (!appointment?.isLeave || !this.mechanicLeaveTypesList?.length) return {};
        const leaveType = this.mechanicLeaveTypesList.find(x => x.id === appointment.leaveOption);
        return leaveType?.colorCode ? { 'background-color': leaveType.colorCode } : {};
    }

    async GetMechanicLeaveTypes() {
        await this.service.GetMechanicLeaveTypes().then((response: any) => {
            if (response.responseCode === Constant.SuccessResponseCode) {
                this.mechanicLeaveTypesList = response.responseObject;
            }
        })
    }
}